import qs from 'qs';

export default {
    ...qs.parse(global.location.search, {
        ignoreQueryPrefix: true
    }),
    ...qs.parse(global.location.hash.replace(/^#[^?]*/, ''), {
        ignoreQueryPrefix: true
    })
};
